import React, { useState, useEffect } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { Alterar, Visualizar } from '../../../../components/Acoes'
import { consultar } from '../../../../util/AcessoApi'

const Consulta = (props) => {
    const [data, setData] = useState([])

    useEffect(() => {
        consultar('/preanestesico/formulario', (dados) => setData(dados))
    }, [])

    const columns = React.useMemo(
        () => [{
            id: 'consulta-formulario-pre-anestesico',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'Formulário',
                    accessor: 'descricao',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Grupos',
                    accessor: 'qtd_grupos',
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'Perguntas',
                    accessor: 'qtd_perguntas',
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'Data de Registro',
                    accessor: 'data_registro',
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data',
                        idColuna: "data_registro",
                        datePicker: true,
                        date: true
                    }
                }
            ]
        }], []
    )

    const acoesObj = [
        (propsAcao) => <Visualizar to={'/preanestesico/formulario/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <Alterar to={'/preanestesico/formulario/alteracao/' + propsAcao.id} />
    ]

    return (
        <>
            <div>
                <DataGridAlternativa data={data} columns={columns} setData={setData}
                    caminhoConsultaFiltros='/preanestesico/formulariopaginacao'
                    acoes={true} acoesObj={acoesObj} caminhoBase='/preanestesico/formulario' modulo={props.modulo}
                    titulo={'Consulta Formulários'} tituloLista={'Formulários Pré-Anestésico e Indicadores Assistenciais'} icone='icon-Notepad' />
            </div>
        </>
    )
}

export default Consulta
